function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e63fcd41-5a8e-4449-aa30-f8b40d19ebd9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "bebb8606-bdd1-4586-9d83-a18148581781",
    "data-name": "Wave-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a2a858cd-a496-4097-8ba1-6b8d85fcd9b9",
    "data-name": "Rectangle",
    d: "M0,26.07387c307.50879,0,483.38281,16.01875,656.8125,16.01875S1028.22693,3.75305,1366,0V48H0Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave6;